import React from 'react';

const NAV_ICONS = {
  overview: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.6}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
  ),
  performance: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.6}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 17l6-6 4 4 8-8M14 7h7v7" />
    </svg>
  ),
  payouts: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.6}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M5 6h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2z" />
    </svg>
  ),
  documents: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.6}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m-6-8h6M5 21h14a2 2 0 002-2V7l-5-5H7a2 2 0 00-2 2v15z" />
    </svg>
  ),
  messages: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.6}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l9 6 9-6M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  bank: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.6}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 21h18M4 11h16M5 11v10M19 11v10M9 11v10M15 11v10M3 7l9-4 9 4v4H3V7z" />
    </svg>
  ),
  authorizations: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.6}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3l8 4v6c0 4.5-3.5 8.4-8 9-4.5-.6-8-4.5-8-9V7l8-4z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
    </svg>
  ),
  logout: (
    <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.6}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H9m0-8H5a2 2 0 00-2 2v12a2 2 0 002 2h4" />
    </svg>
  ),
};

const NAV_ITEMS = [
  { id: 'overview',       label: 'Übersicht' },
  { id: 'performance',    label: 'Entwicklung' },
  { id: 'payouts',        label: 'Auszahlungen' },
  { id: 'documents',      label: 'Dokumente' },
  { id: 'messages',       label: 'Postfach' },
  { id: 'bank',           label: 'Bankverbindung' },
  { id: 'authorizations', label: 'Vollmachten' },
];

/**
 * Premium dark sidebar for the customer dashboard.
 */
const CustomerSidebar = ({ activeTab, setActiveTab, badges = {}, onLogout, onClose, animateItems = true }) => {
  return (
    <aside
      className="h-full w-[260px] bg-[#0A0A0A] text-white flex flex-col"
      data-testid="customer-sidebar"
    >
      {/* Brand */}
      <div className="px-7 pt-8 pb-10 flex items-center gap-3">
        <div className="w-11 h-11 rounded-lg flex items-center justify-center border border-[#C5A059]/40 transition-shadow duration-500 hover:shadow-[0_0_24px_-4px_rgba(197,160,89,0.4)]"
             style={{ background: 'linear-gradient(135deg, #1a1a1a, #0a0a0a)' }}>
          <span className="font-heading font-bold text-[#C5A059] text-xl leading-none">V<span className="text-base">+</span></span>
        </div>
        <div>
          <p className="text-[10px] tracking-[0.25em] text-[#C5A059] font-medium">VALUE PLUS</p>
          <p className="text-[10px] text-white/40 mt-0.5">Investor Portal</p>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="ml-auto lg:hidden text-white/60 hover:text-white vp-tactile transition-colors"
            data-testid="sidebar-close"
            aria-label="Menü schließen"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>

      {/* Nav */}
      <nav className={`flex-1 px-3 space-y-1 ${animateItems ? 'vp-stagger' : ''}`}>
        {NAV_ITEMS.map((item) => {
          const isActive = activeTab === item.id;
          const badge = badges[item.id];
          return (
            <button
              key={item.id}
              onClick={() => { setActiveTab(item.id); onClose?.(); }}
              data-active={isActive}
              className={`vp-nav-item vp-tactile group w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-300 ${animateItems ? 'vp-anim-rise' : ''}
                ${isActive
                  ? 'bg-white/[0.04] border border-[#C5A059]/30 text-white shadow-[inset_0_0_30px_rgba(197,160,89,0.06)]'
                  : 'text-white/55 hover:text-white hover:bg-white/[0.03] hover:translate-x-[2px] border border-transparent'}`}
              data-testid={`sidebar-nav-${item.id}`}
            >
              <span className={`transition-colors duration-300 ${isActive ? 'text-[#C5A059]' : 'text-white/40 group-hover:text-[#C5A059]/80'}`}>
                {NAV_ICONS[item.id]}
              </span>
              <span className="flex-1 text-left">{item.label}</span>
              {badge > 0 && (
                <span className="px-1.5 min-w-[20px] text-center text-[10px] font-semibold rounded-full bg-[#C5A059] text-[#0A0A0A] vp-anim-pulse-gold" data-testid={`sidebar-badge-${item.id}`}>
                  {badge > 99 ? '99+' : badge}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Brand card */}
      <div className="mx-4 mb-4 rounded-lg overflow-hidden border border-white/5 bg-gradient-to-b from-white/[0.03] to-transparent transition-all duration-500 hover:border-[#C5A059]/20">
        <div className="px-4 py-4 relative">
          <p className="font-heading text-[#C5A059] text-base leading-tight">Wachstum<br/>mit Vertrauen.</p>
          <p className="text-[10px] text-white/40 mt-2 leading-relaxed">Ihre Werte.<br/>Unsere Verantwortung.</p>
          <svg className="absolute right-2 bottom-2 w-16 h-10 opacity-50" viewBox="0 0 100 50" fill="none" stroke="#C5A059" strokeWidth={1}>
            <path d="M0 40 L25 35 L40 25 L55 28 L70 15 L85 18 L100 5" strokeLinecap="round" />
          </svg>
        </div>
      </div>

      {/* Logout */}
      <button
        onClick={onLogout}
        className="vp-tactile mx-3 mb-6 flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-white/55 hover:text-white hover:bg-white/[0.03] transition-all duration-300"
        data-testid="sidebar-logout"
      >
        <span className="text-white/40">{NAV_ICONS.logout}</span>
        Abmelden
      </button>
    </aside>
  );
};

export default CustomerSidebar;
